import { useAppSelector } from 'common/hooks/state'
import { useDispatch } from 'react-redux'
import { clearError } from './errorSlice'
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import SplashPopup from 'common/components/organisms/SplashPopup'
import usePopup from 'common/hooks/usePopup'
import useToasts from 'common/hooks/useToasts'

const ErrorBoundary: React.FC<any> = ({ children }) => {
  const { type: errorType } = useAppSelector(({ errors }) => errors);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const toast = useToasts();
  const { setPopupData, setPopupVisibility } = usePopup();

  useEffect(() => {
    if (errorType === 'UNAUTHORIZED') {
      setPopupVisibility(true);
      setPopupData({
        variant: 'no-dismiss',
        title: 'Insufficient permissions',
        message:
          "Sorry! It seems that permissions assigned to this user don't allow to view the content of this page",
        actionText: 'Take me back',
        onAction: async () => {
          if (pathname.includes('admin')) {
            navigate('/admin');
          } else {
            navigate('../login')
          }
          setPopupVisibility(false);
          dispatch(clearError());
        },
      })
    }

    if (errorType === 'UNAUTHENTICATED') {
      toast('You do not have access to view this client', 'error')
      if (pathname.includes('admin')) {
        navigate('/admin');
      } else {
        navigate('../login')
      }
    }
  }, [errorType])

  return <SplashPopup>{children}</SplashPopup>
}

export default ErrorBoundary
